export default __webpack_public_path__ + "static/media/np-hero.fe46438f.png";